import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#3E2723] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/assets/images/logo-color.jpg" 
                alt="Farm Dog Oklahoma" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>Farm Dog Oklahoma</h3>
            </div>
            <p className="text-sm text-gray-300 mb-4">
              Transforming Rascals into Reliable Companions: Helping dogs thrive where the land runs wide!
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#C4A052]" style={{ fontFamily: 'Playfair Display, serif' }}>Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-[#C4A052] transition-colors">Home</Link></li>
              <li><Link to="/board-and-trains" className="hover:text-[#C4A052] transition-colors">Board & Trains</Link></li>
              <li><Link to="/city-dog-board-train" className="hover:text-[#C4A052] transition-colors">City Dog Board & Train</Link></li>
              <li><Link to="/in-home-programs" className="hover:text-[#C4A052] transition-colors">In Home Programs</Link></li>
              <li><Link to="/puppy-program" className="hover:text-[#C4A052] transition-colors">Puppy Program</Link></li>
              <li><Link to="/feral-dog-rehab" className="hover:text-[#C4A052] transition-colors">Feral Dog Rehab</Link></li>
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#C4A052]" style={{ fontFamily: 'Playfair Display, serif' }}>More</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[#C4A052] transition-colors">About Us</Link></li>
              <li><Link to="/gallery" className="hover:text-[#C4A052] transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-[#C4A052] transition-colors">Contact</Link></li>
              <li>
                <a 
                  href="/contact"
                  className="hover:text-[#C4A052] transition-colors"
                >
                  Book Free Consult
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#C4A052]" style={{ fontFamily: 'Playfair Display, serif' }}>Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#C4A052]" />
                <a href="tel:+19189927332" className="hover:text-[#C4A052] transition-colors">(918) 992-7332</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-[#C4A052] mt-0.5" />
                <div className="flex flex-col">
                  <a href="mailto:info@farmdogok.com" className="hover:text-[#C4A052] transition-colors">info@farmdogok.com</a>
                  <a href="mailto:micah@farmdogok.com" className="hover:text-[#C4A052] transition-colors">micah@farmdogok.com</a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={16} className="text-[#C4A052]" />
                <span>Tulsa, Oklahoma</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-4">
              <a 
                href="https://www.facebook.com/profile.php?id=100092500893371" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#C4A052] transition-colors"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="https://www.instagram.com/farmdogok/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#C4A052] transition-colors"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Farm Dog Oklahoma. All rights reserved.</p>
            <p className="text-[#C4A052] font-semibold">www.FarmDogOklahoma.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;